import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: null,
        isLogin: false,
    },
    mutations: {
        restore(state) {
            let userInfo = localStorage.getItem("userInfo")
            if (userInfo) {
                this.commit('login', JSON.parse(userInfo))
            }
        },
        updateUser(state, user) {
            state.user = user;
            localStorage.setItem("userInfo", JSON.stringify(user));
        },
        clearUser(state) {
            state.user = null;
            localStorage.removeItem("userInfo")
        },
        // 登录
        login(state, user) {
            state.isLogin = true;
            localStorage.setItem("isLogin", true);
            this.commit('updateUser', user)
        },
        // 退出
        logout(state) {
            state.isLogin = false;
            localStorage.removeItem("isLogin");
            this.commit('clearUser')
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js